/**
 * @generated SignedSource<<6258da864cdb88662188b4003b3dd070>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventCapacityType = "ATTENDEES" | "GROUPS";
export type EventPrimaryChargeType = "PER_PERSON" | "PER_SIGN_UP";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type FormStepManager_event$data = {
  readonly allowedGroupSizes: ReadonlyArray<number | null | undefined>;
  readonly capacityType: EventCapacityType | null | undefined;
  readonly maxGuestCount: number;
  readonly maxMemberCount: number;
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly prePaymentRequirement: PrePaymentRequirement | null | undefined;
  readonly primaryChargeType: EventPrimaryChargeType | null | undefined;
  readonly spotsAvailable: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventFormStep_event" | "EventSignUpPrimaryChargePaymentAssignment_event" | "GroupRegistrationDisplay_event" | "PrimaryChargeSelectionStep_event">;
  readonly " $fragmentType": "FormStepManager_event";
};
export type FormStepManager_event$key = {
  readonly " $data"?: FormStepManager_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"FormStepManager_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormStepManager_event",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GroupRegistrationDisplay_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventFormStep_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PrimaryChargeSelectionStep_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignUpPrimaryChargePaymentAssignment_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryChargeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prePaymentRequirement",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowedGroupSizes",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "529833bbc13361f9d26e1f8b4a80e06b";

export default node;
